import React, { useMemo } from 'react';

import { KeyboardArrowRight } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';

import ProtectedChip from 'pages/item/v2/components/ProtectedChip';
import ProtectedData, { isProtectedData } from 'pages/item/v2/components/ProtectedData';
import formatDate from 'utils/format-date';

import useStyles from './styles';

interface Props {
    id: string;
    title: string;
    published: string;
    type: string;
    className?: string;
}

const ReferenceGroupItem: React.FC<Props> = ({ id, type, title, published, className }) => {
    const { classes, cx } = useStyles();

    const href = useMemo(() => (isProtectedData(type) || isProtectedData(id) ? null : `/${type}/${id}`), [id, type]);
    return (
        <div className={cx(classes.root, className)}>
            <div className={classes.titleBlock}>
                <Typography
                    className={classes.title}
                    variant="body2"
                    {...(href ? { component: 'a', href, target: '_blank' } : {})}
                >
                    <ProtectedData data={title} />
                </Typography>
                <ProtectedChip
                    data={published}
                    classes={{ root: classes.chip, label: classes.label }}
                    label={({ isProtected }) =>
                        isProtected ? 'yyyy-MM-dd HH:mm:ss' : formatDate(published, 'yyyy-MM-dd HH:mm:ss')
                    }
                />
            </div>
            <IconButton
                className={classes.icon}
                size="medium"
                {...(href ? { href, target: '_blank' } : { disabled: true })}
            >
                <KeyboardArrowRight />
            </IconButton>
        </div>
    );
};

export default ReferenceGroupItem;
